import { Zap, Layers, Database, Users, TrendingUp } from "lucide-react";

const t = {
  fr: {
    title: "Avantages d'Évolutivité",
    subtitle: "Conçu pour Évoluer dès le Premier Jour",
    intro: "EcoLunch évolue rapidement parce que :",
    cards: [
      { icon: Layers, title: "Un Code, Une Infrastructure", items: ["Pas de complexité de marque blanche", "Pas de déploiements par traiteur", "Pas de fragmentation"] },
      { icon: Database, title: "Segmentation des Données, Pas de Duplication", items: ["Les traiteurs partagent la même plateforme", "Isolés par permissions", "Utilisation efficace des ressources"] },
      { icon: Users, title: "Faible Friction d'Intégration", items: ["Traiteur → opérationnel instantanément", "École → intégrée instantanément", "Parents → 100 % libre-service"] },
      { icon: TrendingUp, title: "Adoption Institutionnelle Virale", items: ["Chaque nouveau traiteur amène de nouveaux parents", "De nouvelles écoles rejoignent le réseau", "La notoriété locale de la marque croît", "Plus de données → meilleure optimisation"] },
      { icon: Zap, title: "TAM Naturellement Expansif", items: ["Programmes de repas scolaires", "Garderies", "Camps d'été", "Centres communautaires", "Plans de repas d'entreprise (futur)"] },
    ],
  },
  en: {
    title: "Scalability Advantages",
    subtitle: "Built to Scale from Day One",
    intro: "EcoLunch scales quickly because:",
    cards: [
      { icon: Layers, title: "One Code, One Infrastructure", items: ["No white-label complexity", "No per-caterer deployments", "No fragmentation"] },
      { icon: Database, title: "Data Segmentation, Not Duplication", items: ["Caterers share the same platform", "Isolated by permissions", "Efficient resource usage"] },
      { icon: Users, title: "Low Integration Friction", items: ["Caterer → operational instantly", "School → integrated instantly", "Parents → 100% self-service"] },
      { icon: TrendingUp, title: "Viral Institutional Adoption", items: ["Each new caterer brings new parents", "New schools join the network", "Local brand awareness grows", "More data → better optimization"] },
      { icon: Zap, title: "Naturally Expanding TAM", items: ["School meal programs", "Daycares", "Summer camps", "Community centers", "Corporate meal plans (future)"] },
    ],
  },
};

export default function ScalabilitySection({ lang }) {
  const c = t[lang];
  return (
    <section data-testid="scalability-section" className="py-16 sm:py-24 bg-darker">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-primary/20 mb-6 glow-primary">
            <Zap className="h-8 w-8 sm:h-10 sm:w-10 text-primary" />
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">{c.title}</h2>
          <p className="text-xl text-white/70">{c.subtitle}</p>
        </div>
        <div className="max-w-4xl mx-auto mb-12 text-center">
          <p className="text-lg text-white/80">{c.intro}</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {c.cards.map((card) => {
            const Icon = card.icon;
            return (
              <div key={card.title} className="rounded-xl border text-card-foreground shadow hover-lift bg-dark border-primary/30 hover:border-primary transition-all duration-300">
                <div className="p-6 pt-6 sm:pt-8 pb-6 sm:pb-8">
                  <div className="inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-primary/20 mb-4 sm:mb-6 glow-primary">
                    <Icon className="h-6 w-6 sm:h-7 sm:w-7 text-primary" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-4">{card.title}</h3>
                  <ul className="space-y-2 sm:space-y-3">
                    {card.items.map((item) => (
                      <li key={item} className="flex items-start gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0 mt-2 glow-primary" />
                        <span className="text-sm text-white/70">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
